export default {
    namespaced: true,
    state: () => ({
        is_initialized: false,
        search_state: 'basic',
        search_state_covers: 'basic',
        is_epicvault_enabled: window.is_epicvault_enabled,
        display_notice: false,
    }),
    mutations: {
        setInitialized(state, flag) {
            state.is_initialized = flag;
        },
        setSearchState(state, search_state) {
            state.search_state = search_state;
        },
        setSearchStateCovers(state, search_state) {
            state.search_state_covers = search_state;
        },
        setEpicVaultModule(state, is_epicvault_enabled) {
            state.is_epicvault_enabled = is_epicvault_enabled;
        },
        setDisplayNotice(state, display_notice) {
            state.display_notice = display_notice;
        },
    },
    getters: {
        isEpicvaultEnabled(state) {
            return state.is_epicvault_enabled;
        },
    },
    actions: {
        updateInitialized({ commit }, payload) {
            commit('setInitialized', payload);
        },
        updateSearchState({ commit }, payload) {
            commit('setSearchState', payload);
        },
        updateSearchStateCovers({ commit }, payload) {
            commit('setSearchStateCovers', payload);
        },
        updateEpicVaultModule({ commit }, payload) {
            commit('setEpicVaultModule', payload);
        },
        updateDisplayNotice({ commit }, payload) {
            commit('setDisplayNotice', payload);
        },
    },
};
